import { usePropertyDayOfWorkCompleted } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { DateTimeBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { formatDate } from '../../../../../../admin/src/common/SharedFunctions';
import { DateTimeBoxLabelSize } from '@apply/components/src/components/controls/DateBox/DateTimeBox';

interface DayOfWorkCompletedProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const DayOfWorkCompleted: React.FC<DayOfWorkCompletedProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const [dayOfWorkCompleted, set_dayOfWorkCompleted] = usePropertyDayOfWorkCompleted(propertyGuid);
    const label = 'Last Day of Work Completed?';

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatDate(dayOfWorkCompleted)}
                />
            ) : (
                <DateTimeBox
                    id='dayOfWorkCompleted'
                    required={required}
                    value={dayOfWorkCompleted ?? undefined}
                    onChange={(value) => set_dayOfWorkCompleted(value)}
                    label={label}
                    labelSize={DateTimeBoxLabelSize.Small}
                    width='220px'
                    max={new Date()}
                    dateOutOfRangeMessage='Date cannot be in the future'
                />
            )}
        </>
    );
};
